module.exports = "/_next/static/images/725c3677f6acbc834bd50cdc0d736b2b-rewards-smiles@3x.png.webp";